import type { SDKConfig, AdOptions, AdCreative, TrackingEvent } from './types';
import { NetworkError, MessageType, ConfigError } from './types';
import { sendToBackground } from './messaging';
import { logger } from './logger';

/**
 * Get the current configuration from background worker
 */
export async function getConfig(): Promise<SDKConfig> {
  try {
    const response = await sendToBackground<SDKConfig>({
      type: MessageType.GET_CONFIG,
      payload: {},
    });
    return response.data!;
  } catch (error) {
    throw new ConfigError(
      'Failed to get SDK config. Make sure initializePlayaYield() is called in your background script.'
    );
  }
}

/**
 * Request an ad from the backend
 */
export async function requestAd(options: AdOptions): Promise<AdCreative> {
  // Always use background for requests (config is stored there)
  try {
    const response = await sendToBackground<AdCreative>({
      type: MessageType.AD_REQUEST,
      payload: { options },
    });
    return response.data!;
  } catch (error) {
    throw new NetworkError(
      `Ad request failed: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`
    );
  }
}

/**
 * Track an event (impression or click)
 */
export async function trackEvent(event: TrackingEvent): Promise<void> {
  try {
    await sendToBackground({
      type: MessageType.TRACK_EVENT,
      payload: { event },
    });
  } catch (error) {
    logger.error('Tracking failed:', error);
    // Don't throw - tracking failures shouldn't break the app
  }
}
